<template>
<div id="recruit">
  <!-- <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
  <v-notificationTop :noticeInfo="noticeInfo" ></v-notificationTop>
  <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header> -->
  <div  id="runTaskDiv" >
      <iframe  :src="runRecuritUrl" width="100%" frameborder="0"  ></iframe>
  </div>
  <!-- <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer> -->
  <v-backToTop></v-backToTop>
</div>
</template>
<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import backToTop from '@/components/backToTop'
import footer from '@/components/v-footer'
import notificationTop from '@/components/notificationTop'

export default {
  data () {
    return {
      webConfigInfo:{},
      paramInfo:{},
      yellowPage:"",
      footerColumnInfos:[],
      warehousingUrl:"",
      navigationColumnInfos:[],
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{},
      loading:true,
      runRecuritUrl:'',
      noticeInfo:[]
    }
  },
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-footer': footer,
    'v-backToTop': backToTop,
    'v-notificationTop': notificationTop,
  },
  created () {
    let query = this.$route.query;
    this.runRecuritUrl = query.redirctUtl;
    // $("#runTaskDiv").html("<iframe  src='"+ this.runRecuritUrl +"' height='1200' width='100%' frameborder='0'  ></iframe>");
    // this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
    // }).then((res) => {
    //   this.loading=false;
    //   this.data = res.data;
    //   this.ratationTime =  Number(this.data.ratationTime);
    //   this.noticeInfo = this.data.noticeDtos;
    //   this.navigationColumnInfos = this.data.navigationColumnInfos;
    //   this.footerColumnInfos = this.data.footerColumnInfos;
    //   this.webConfigInfo = this.data.webConfigInfoDto;
    //   this.yellowPage = this.data.supplierInfo.supllierUrl;
    //   this.yellowPageColumn = this.data.yellowPageColumn;
    //   this.hitSearchUrl = this.data.hitSearchUrl;
    //   this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
    // }).catch((err) => {
    //   console.log(err)
    // })
  },
  methods:{
    jump(url){
      window.location.href = url;
    }
  }
}
</script>

<style scoped lang="stylus">
@media only screen and (max-width: 766px)
  .games
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/recruit/index.vue